import { Pipe, PipeTransform } from '@angular/core';
import { Activity } from '@data-terminal/shared-models/operation';

@Pipe({
    standalone: true,
    name: 'activityById',
})
export class ActivityByIdPipe implements PipeTransform {
    transform(activityId: string, activities: Activity[]): Activity | undefined {
        return activities.find((activity) => activity.actId === activityId);
    }
}
